<template>
  <div class="">
    <step-options1 ref="listStepOptions" :feature-selected-attribute="featureSelectedAttribute"
                       id="listStepOptions" v-model="listStepVariableWatcher"
                       :options="featureAttributesFirstOptions"/>
  </div>
</template>

<script>
import StepOptions1 from "./StepOptionManager/StepOptions1.vue";

export default {
  name: "FeatureInputListStep",
  components: {StepOptions1},
  data() {
    return {
      listStepVariableWatcher: null,
    }
  },
  props: {
    featureProduct: {},
    product: {},
  },
  computed: {
    featureAttributes() {
      return this.featureProduct.feature.feature_attributes
    },
    featureAttributesFirstOptions() {

      const groups = {};
      this.featureAttributes.forEach((attribute) => {
        const values = attribute.value.split(":");
        const firstValue = values[0];
        if (Object.keys(groups).indexOf(firstValue) === -1) {
          groups[firstValue] = []
        }
        groups[firstValue].push(attribute)
      });
      return groups;
    },
    featureSelectedAttribute() {
      let feature_attribute_id = this.featureProduct.feature_attribute_id;
      if (feature_attribute_id != null) {

        for (const [_, item] of Object.entries(this.featureAttributes)) {
          if (item.id === feature_attribute_id) {
            return item.value
          }
        }

      }
    }
  },
  methods: {
    findSelectedOptionsObject(selectedOptionResult) {

      for (const [_, item] of Object.entries(this.featureAttributes)) {
        if (item.value === selectedOptionResult) {
          this.featureProduct.feature_attribute_id = item.id
        }
      }

    }
  },
  watch: {
    listStepVariableWatcher: {
      handler(oldValue, newValue) {
        setTimeout(() => {
          let result = []
          // Access the listStepOptions ref
          const listStepOptions = this.$refs.listStepOptions;

          // Get all select box values inside it
          if (listStepOptions) {
            const selectBoxes = listStepOptions.$el.querySelectorAll('.list-step-options-select');
            selectBoxes.forEach(selectBox => {
              result.push(selectBox.value)
            });
            result = result.join(':')
            this.findSelectedOptionsObject(result)
          }
        }, 0)


      },
      deep: true
    }
  }
}
</script>

<style scoped>

</style>